import React from "react";
import ForecastProvider from "../contexts/ForecastContext";
import { ShipmentHeaderProvider } from "../contexts/ShipmentHeaderContext";
import ShipmentSubmit from "./ShipmentSubmit";

const ShipmentSubmitContainer = () => {
  return (
    <ShipmentHeaderProvider>
      <ForecastProvider>
        <ShipmentSubmit />
      </ForecastProvider>
    </ShipmentHeaderProvider>
  );
};

export default ShipmentSubmitContainer;
